module.exports = __webpack_public_path__ + "static/media/delete.94fe0261.svg";